import SuperSimpleAccordions from './js/accordions';

export {SuperSimpleAccordions};
